export function debug() {}
export function error() {}
export function info() {}
export function warn() {}
